import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  console.log("Sidebar props - isOpen:", isOpen, "onClose:", typeof onClose);

  const menuItems = [
    { path: "/", label: "[Home]" },
    { path: "/about", label: "[About]" },
    { path: "/mission-briefing", label: "[Rules and Regulations]" },
    { path: "/sponsors", label: "[Sponsors]" },
    { path: "/register", label: "[Register]" },
  ];

  const handleLinkClick = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <h2>DARE TO DECRYPT</h2>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${
                location.pathname === item.path ? "active" : ""
              }`}
              onClick={handleLinkClick}
            >
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
